import { getToken, onMessage, getMessaging } from 'firebase/messaging';
import { messaging } from '../config/firebase';
import { saveNotificationToken } from '../services/notificationService';

const registerServiceWorker = async () => {
  try {
    if ('serviceWorker' in navigator) {
      const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js', {
        scope: '/firebase-cloud-messaging-push-scope'
      });
      console.log('Service Worker registered with scope:', registration.scope);
      return registration;
    }
  } catch (error) {
    console.error('Service Worker registration failed:', error);
  }
};

export const getFCMToken = async () => {
  try {
    const token = await getToken(messaging, {
      vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY
    });
    return token;
  } catch (error) {
    console.error('Lỗi khi lấy FCM token:', error);
    return null;
  }
};

const checkiOSDevice = async () => {
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  
  if (isIOS) {
    // Kiểm tra xem app đã được add to home screen chưa
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches ||
                        window.navigator.standalone ||
                        document.referrer.includes('ios-app://');

    if (!isStandalone) {
      throw new Error('Vui lòng thêm ứng dụng vào màn hình chính để nhận thông báo');
    }

    // Kiểm tra version iOS
    const iOSVersion = parseInt((navigator.userAgent).match(/OS (\d+)_/)[1], 10);
    if (iOSVersion < 16.4) {
      throw new Error('Yêu cầu iOS 16.4 trở lên để nhận thông báo');
    }

    return true;
  }
  return false;
};

export const requestNotificationPermission = async (shouldSaveToken = false) => {
  try {
    if (!('Notification' in window)) {
      throw new Error('Trình duyệt này không hỗ trợ thông báo');
    }

    // Kiểm tra iOS
    const isIOS = await checkiOSDevice();
    
    // Đăng ký service worker
    if ('serviceWorker' in navigator) {
      await registerServiceWorker();
    }

    // Xin quyền notification
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      try {
        const token = await getFCMToken();
        
        if (token) {
          if (shouldSaveToken) {
            const result = await saveNotificationToken(token);
            if (result.success) {
              // Lưu thông tin device để debug
              localStorage.setItem('fcm_token', token);
              localStorage.setItem('device_info', JSON.stringify({
                isIOS,
                userAgent: navigator.userAgent,
                platform: navigator.platform,
                timestamp: new Date().toISOString()
              }));
              console.log('Lưu token thành công');
            }
          }
          
          return {
            success: true,
            token: token,
            message: 'Đăng ký nhận thông báo thành công'
          };
        } else {
          throw new Error('Không thể lấy token thông báo');
        }
      } catch (error) {
        throw new Error('Lỗi khi lấy token: ' + error.message);
      }
    } else {
      throw new Error('Bạn cần cấp quyền thông báo để nhận được thông báo từ ứng dụng');
    }
  } catch (error) {
    return {
      success: false,
      message: 'Lỗi khi xin quyền thông báo: ' + error.message
    };
  }
};

// export const onMessageListener = () => {
//   return new Promise((resolve) => {
//     onMessage(messaging, (payload) => {
//       resolve(payload);
//     });
//   });
// };

export const handleTokenRefresh = () => {
  try {
    let currentToken = null;

    const checkToken = async () => {
      try {
        const newToken = await getFCMToken();
        if (newToken && newToken !== currentToken) {
          currentToken = newToken;
        }
      } catch (error) {
        console.error('Lỗi khi kiểm tra token:', error);
      }
    };

    checkToken();
    const intervalId = setInterval(checkToken, 60 * 60 * 1000);

    return () => {
      clearInterval(intervalId);
    };
  } catch (error) {
    console.error('Lỗi khi đăng ký refresh token:', error);
    return null;
  }
};